export const gladiator_hoodie = {
  msrp: 64.99,
  infoLink: 'https://www.teamtriton.com/gladiator-hoodie.html',
  items: [
    {
      number: 'GH99',
      hasModel: false,
    },
    {
      number: 'GH100',
      hasModel: false,
    },
    {
      number: 'GH101',
      hasModel: false,
    },
    {
      number: 'GH102',
      hasModel: false,
    },
    {
      number: 'GH103',
      hasModel: false,
    },
    {
      number: 'GH104',
      hasModel: false,
    },
    {
      number: 'GH105',
      hasModel: false,
    },
    {
      number: 'GH106',
      hasModel: false,
    },
    {
      number: 'GH107',
      hasModel: false,
    },
    {
      number: 'GH108',
      hasModel: false,
    },
    {
      number: 'GH109',
      hasModel: false,
    },
  ],
};
